import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';
import { transformKeysToCamelCase, transformKeysToSnakeCase } from 'helpers/core';

const SOURCE = 'PARTNER_DASHBOARD';

const post = (httpClient, { smsSettings, userId }) => {
  const { phoneNumber, countryCode, optIn } = smsSettings;
  const payload = {
    phone: {
      phoneNumber,
      countryCode,
    },
    source: SOURCE,
    optIn,
  };
  const endpoint = URLS.user.updateSmsSubscriptionStatus(userId);

  return httpClient.post(endpoint, transformKeysToSnakeCase(payload));
};

const get = httpClient => {
  const endpoint = URLS.user.smsSubscriptionStatus;
  return httpClient
    .get(endpoint)
    .then(transformKeysToCamelCase)
    .then(data => data.data);
};

const handler = ({ httpClient }, data) => {
  let promise = Promise.resolve();

  if (data?.smsSettings) {
    promise = post(httpClient, data);
  }

  return promise.then(() => get(httpClient, data));
};

export default makeEntityScaffold('USER_SMS_SUBSCRIPTION_STATUS', handler);
